import type { Client, ClientColor } from "@iltocat/shared";

/**
 * A client's name as a tag in the client's own colour, wherever a client is
 * named: the Deployed pile, a held unit's badge, an item's card, the Clients
 * list. The colour is a name (`data-color`) that the stylesheet turns into a
 * token pair, so the tag follows the theme; no colour is the plain grey.
 *
 * `spot`, where at the client, sits beside the tag rather than in it: the tag
 * is who, the spot is only a note.
 */
export function ClientTag({
  name,
  color,
  spot = "",
}: {
  name: string;
  color: ClientColor | null | undefined;
  spot?: string;
}) {
  return (
    <span className="client-at">
      <span className="client-tag" data-color={color ?? undefined}>
        <span className="client-tag-dot" aria-hidden="true" />
        <span className="client-tag-name">{name}</span>
      </span>
      {spot && <span className="client-spot">{spot}</span>}
    </span>
  );
}

/** Each client's colour by id, for the lists that carry only a client's id and name. */
export const clientColors = (clients: Client[]): Map<string, ClientColor | null> =>
  new Map(clients.map((client) => [client.id, client.color]));
